var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"title":_vm.$t('errors.disabled.title'),"description":_vm.$t('errors.disabled.description')},on:{"back":_vm.back}})}
var staticRenderFns = []

export { render, staticRenderFns }